module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qc3Mfm/tc-custom/cover.jpg?1685327424665?1692044794263",
      "alt": "This image is the cover for the book Hat Trick Overtime: Summer Camp, Hat Trick (Simon and Alex)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hat Trick Overtime: Summer Camp, Hat Trick (Simon and Alex)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Simon and Alex, now between their junior and senior years at the University of Michigan, decide to put their jobs on hold for a month and take the opportunity to coach hockey at a summer camp for teenagers."), _c('br'), _c('br'), _vm._v("They have a cabin full of good players to work with and the focus is getting them ready to win the camp championship. One camper, sixteen-year-old Dylan, requests extra help because he needs to get a scholarship and the guys make it their mission to help him succeed."), _c('br'), _c('br'), _vm._v("With their best friend Leo along for the trip, Simon and Alex are set up for a great time at camp, until another coach tries to seduce them. How they respond to the unwanted advances, while balancing commitments to their campers, will put them both -- and their relationship -- to the test.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeff Adams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jeff lives in rural Northern California with his husband of twenty years, Will. He’s the author of the young adult/new adult Hat Trick series, as well as other short stories and novellas. He also co-hosts the weekly show Jeff & Will’s Big Gay Fiction Podcast. For more information, visit JeffAdamsWrites.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0